import React, {useEffect, useState} from "react";
import {Header} from "./Header";
import {Sidebar} from "./Sidebar";
import styles from "./style.module.scss";
import {useLocation} from "react-router-dom";
import {constant} from "@utils";
import {Images, ScreenId, Svgs} from "@assets";
import {useNav} from "@hook";

interface IProps {
  children: JSX.Element;
}

export default function Layout({children}: IProps) {
  const {navigate: userNavigater} = useNav();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(
    window.innerWidth > constant.MOBILE_WIDTH,
  );
  const [commonData, setCommonData] = useState<any>({});

  async function getCommonData() {
    try {
      // const {data, success} = await adminApi.admin.apiGetCommon();
      // if (success) {
      //   setCommonData(data);
      // }
    } catch (error) {
      console.error("getCommonData error", error);
    }
  }

  function toggleMenu() {
    setIsOpen(!isOpen);
  }

  function closeMenu() {
    setIsOpen(false);
  }

  useEffect(() => {
    getCommonData();

    if (window.innerWidth <= constant.MOBILE_WIDTH) {
      closeMenu();
    }
  }, [location]);

  return (
    <div className={styles.pane}>
      <Header isOpen={isOpen} toggleMenu={toggleMenu} />
      <div
        className={[styles.sidebar, isOpen ? styles.open : styles.close].join(
          " ",
        )}>
        <div
          className={styles.sidebarHeader}
          onClick={() => userNavigater({url: ScreenId.HOME})}>
          <Svgs.Logo />
        </div>
        <Sidebar />
      </div>
      <div className={styles.content}>
        <div
          className={[
            styles.sidebarPlaceholder,
            isOpen ? styles.open : styles.close,
          ].join(" ")}
        />
        <div className={styles.mainContent}>{children}</div>
      </div>
    </div>
  );
}
